import classnames from "classnames";

import style from "./style.module.scss";
import themes from "../themes";
import CoverBackground from "./background";
import { ArrowSelector, ColorPicker, LimitedInput } from "../../../../ui";
import type { PhotoBookOptions, PhotoValue } from "../../../types";

interface CoverProps {
  productId: string;
  userId: string;
  options: PhotoBookOptions;
  setOptions: (options: Partial<PhotoBookOptions>) => void;
}

interface CoverPreviewProps {
  options: PhotoBookOptions;
  className?: string;
}

function Cover({ productId, userId, options, setOptions }: CoverProps) {
  const selectedTheme = themes.find((theme) => theme.value === options.theme) || themes[0];
  const color = options.color ? options.color : selectedTheme ? selectedTheme.color : null;
  const onChangeTheme = (theme: string) => {
    setOptions({ theme });
  };
  const onChangeCoverPhoto = (photo: PhotoValue) => {
    setOptions({ coverPhoto: photo });
  };
  const onChangeTitle = (title: string) => setOptions({ title });

  return (
    <div className={style.coverContainer}>
      <div className={style.preview}>
        <CoverBackground
          options={options}
          productId={productId}
          userId={userId}
          onChange={onChangeCoverPhoto}
        >
          <LimitedInput
            containerClassName={style.coverTitle}
            containerStyle={
              selectedTheme && selectedTheme.top ? { top: selectedTheme.top } : { top: "20%" }
            }
            className={style.coverTitleInput}
            maxLength={40}
            value={options.title || ""}
            placeholder="Mon livre photo"
            onChange={(event) => onChangeTitle(event.target.value)}
          />
        </CoverBackground>
      </div>
      <div className={style.form}>
        <div className={style.formField}>
          <LimitedInput
            className={style.title}
            maxLength={40}
            placeholder="Donner un titre au livre..."
            value={options.title || ""}
            onChange={(event) => onChangeTitle(event.target.value)}
          />
        </div>
        <div className={style.formField}>
          <ArrowSelector
            options={themes.filter((t) => !t.hidden)}
            value={options.theme || themes[0].value}
            onChange={onChangeTheme}
            renderLabel={(label) => `Thème : ${label}`}
          />
        </div>
        <div className={classnames(style.formField, style.colorField)}>
          <ColorPicker value={color} onChange={(color) => setOptions({ color })} />
        </div>
      </div>
    </div>
  );
}

Cover.Preview = ({ options, className }: CoverPreviewProps) => {
  const selectedTheme = themes.find((theme) => theme.value === options.theme) || themes[0];
  return (
    <CoverBackground options={options} className={className} isPreview>
      <div
        className={style.coverTitle}
        style={selectedTheme && selectedTheme.top ? { top: selectedTheme.top } : { top: "20%" }}
      >
        {options.title}
      </div>
    </CoverBackground>
  );
};

export default Cover;
